import { clientApi as api } from '@common/api'
import { useAppDispatch, useAppSelector, useTranslate } from '@common/hooks'
import { MenuContext } from '@common/widgets/MenuButton/MenuButton'
import { stopApplication } from '@redux/slices/application/application'
import cx from 'classnames'
import { useContext, useState } from 'react'

import classNames from './styles.module.scss'


export default function StopButton(): JSX.Element | null {
  const application = useAppSelector(store => store.application.data) as IApplication
  const [initialRender] = useState(application.isInstalled && application.isActive)
  const { translate } = useTranslate()
  const dispatch = useAppDispatch()
  const { handleCloseMenu } = useContext(MenuContext)

  const stopApp = async () => {
    try {
      await api.post<unknown>('/api/apps/stop', {
        appId: application.id,
      })
      dispatch(stopApplication())
      handleCloseMenu()
    } catch (error) {}
  }
  const isDisabled = !application.isInstalled || (application.isInstalled && !application.isActive)

  if(!initialRender) {
    return null
  }

  return (
    <label
      onClick={isDisabled ? undefined : stopApp}
      className={cx(classNames.stop, isDisabled && classNames.disabled)}
      data-test="stop-btn"
    >
      {application.isInstalled && !application.isActive ? translate('Stopped') : translate('Stop')}
    </label>
  )
}
